"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataType = void 0;
var getDataType = function (property, assetTypeDefinitions) { var _a; return (_a = assetTypeDefinitions.find(function (def) { return def.columnName === property; })) === null || _a === void 0 ? void 0 : _a.dataType; };
exports.getDataType = getDataType;
//# sourceMappingURL=getDataType.js.map